import { TextField } from "@mui/material";

export type FilterSearchItemProps = {
    title: string;
    val: string;
    setVal: React.Dispatch<React.SetStateAction<string>>;
};
const FilterSearchItem = ({ title, val, setVal }: FilterSearchItemProps) => {
    return (
        <div className="flex flex-col px-4 py-2 gap-3 my-2 mx-4 rounded bg-neutral-50 dark:bg-momeento-100">
            <h3 className="font-medium dark:text-white">{title}</h3>
            <TextField
                id="search-user"
                name="search-user"
                label="Search"
                variant="outlined"
                size="small"
                sx={{ width: "100%" }}
                value={val}
                onChange={(e) => setVal(e.target.value)}
            />
        </div>
    );
};

export default FilterSearchItem;
